import React from 'react';
import '../../App.css';
import Navbar from '../Navbar';

export default function Future() {
 return (
    <>
      <Navbar />
      <h1 className='future'>Hi, I am from future. I dont know what I will be just yet.</h1>
    </>
  ); 
}
